import { render, staticRenderFns } from "./OrderInfo.vue?vue&type=template&id=23b74c7d&"
import script from "./OrderInfo.vue?vue&type=script&lang=ts&"
export * from "./OrderInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports